var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var ActionButtons = createReactClass({

	propTypes: {
		inEditMode: PropTypes.bool,
		isSaving:  PropTypes.bool,
		isDisabled: PropTypes.bool,
		onEdit: PropTypes.func,
		onSave: PropTypes.func,
		onCancel: PropTypes.func
	},

	getDefaultProps: function() {
		return {
			isDisabled: false
		};
	},

	render: function() {
		var saveButtonText = "Save";
		if(this.props.isSaving) {
			saveButtonText = "Saving..."
		}

		var buttons;
		if(this.props.inEditMode) {
			buttons = (
				<div>
					<input
						type="submit"
						className="btn btn-primary"
						onClick={this.props.onSave}
						value={saveButtonText}
						disabled={this.props.isDisabled}
					/>
					<button
						type="button"
						className="btn btn-default"
						onClick={this.props.onCancel}
					>Cancel
					</button>
				</div>
			);
		} else {
			buttons = (
				<div>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.props.onEdit}
					>Edit
					</button>
				</div>
			);
		}

		return (
			<div className="confirm-actions">

				{buttons}
			</div>
		);
	}
});

module.exports = ActionButtons;
